import React, { useState, useEffect, useRef } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import './Puntos.css';

export default function Puntos({ loggedUserRoles, loggedUserEmail, username }) {
  const [empleados, setEmpleados] = useState([]);
  const [selectedEmpleado, setSelectedEmpleado] = useState(null);
  const [selectedCiudad, setSelectedCiudad] = useState(null);
  const [selectedTienda, setSelectedTienda] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [ciudades, setCiudades] = useState([]);
  const [tiendas, setTiendas] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [tiposCategoria, setTiposCategoria] = useState([]);
  const [areas, setAreas] = useState([]);
  const [selectedTipoCategoria, setSelectedTipoCategoria] = useState(null);
  const [selectedArea, setSelectedArea] = useState(null);
  const [selectedDescripcion, setSelectedDescripcion] = useState('');
  const [selectedCategoriaId, setSelectedCategoriaId] = useState(null);
  const [selectedTipoCategoriaId, setSelectedTipoCategoriaId] = useState(null);
  const [selectedAreaId, setSelectedAreaId] = useState(null);
  const [puntos, setPuntos] = useState('');
  const [comentario, setComentario] = useState('');
  const [fechaHoraActual, setFechaHoraActual] = useState('');
  const [toastSeverity, setToastSeverity] = useState('error');
  const [toastMessage, setToastMessage] = useState('');
  const toast = useRef(null); // Referencia para el Toast

  useEffect(() => {
    // Llamadas a la API para cargar datos iniciales
    fetch('/api/empleado/ciudad/findall')
      .then(response => response.json())
      .then(data => setCiudades(data))
      .catch(error => console.error('Error fetching ciudades:', error));

    fetch('/api/categoria/findall')
      .then(response => response.json())
      .then(data => setCategorias(data))
      .catch(error => console.error('Error fetching categorías:', error));

    fetch('/api/categoria/tipocategoria/findall')
      .then(response => response.json())
      .then(data => {
        // Filtrar tipos de categoría según el rol del usuario
        const filteredTiposCategoria = data.filter(tipo => {
          if (loggedUserRoles.includes('ALTO')) {
            return tipo.nombre === 'Positivo nivel 1' || tipo.nombre === 'Preocupante nivel 1' || tipo.nombre === 'Preocupante nivel 2' || tipo.nombre === 'Preocupante nivel 3';
          } else if (loggedUserRoles.includes('MEDIO')) {
            return tipo.nombre === 'Positivo nivel 1' || tipo.nombre === 'Preocupante nivel 1' || tipo.nombre === 'Preocupante nivel 2';
          } else if (loggedUserRoles.includes('BAJO')) {
            return tipo.nombre === 'Positivo nivel 1' || tipo.nombre === 'Preocupante nivel 1';
          }
          return false;
        });
        setTiposCategoria(filteredTiposCategoria);
      })
      .catch(error => console.error('Error fetching tipos de categoría:', error));

    fetch('/api/categoria/area/findall')
      .then(response => response.json())
      .then(data => setAreas(data))
      .catch(error => console.error('Error fetching áreas de categorías:', error));

    // Establecer fecha y hora actual
    const interval = setInterval(() => {
      const currentDateTime = new Date().toLocaleDateString('en-CA');
      setFechaHoraActual(currentDateTime);
    }, 1000);

    return () => clearInterval(interval);
  }, [loggedUserRoles]);

  useEffect(() => {
    // Cargar tiendas cuando se selecciona una ciudad
    if (selectedCiudad) {
      fetch(`/api/empleado/almacen/finbyciudad/${selectedCiudad}`)
        .then(response => response.json())
        .then(data => setTiendas(data))
        .catch(error => console.error('Error fetching tiendas:', error));
    }
  }, [selectedCiudad]);

  useEffect(() => {
    // Cargar empleados cuando se selecciona una tienda
    if (selectedTienda) {
      fetch(`/api/empleado/findbyalmacen/${selectedTienda}`)
        .then(response => response.json())
        .then(data => setEmpleados(data))
        .catch(error => console.error('Error fetching empleados:', error));
    }
  }, [selectedTienda]);

  useEffect(() => {
    if (selectedTipoCategoria && selectedArea) {
      fetch(`/api/categoria/findbydescripcionesporAreaporTipo/${selectedArea.id}/${selectedTipoCategoria.id}`)
        .then(response => response.json())
        .then(data => {
          // Filtrar las categorías válidas que tienen tipoCategoria y area
          const validCategorias = data.filter(categoria =>
            categoria.idTipoCategoria === selectedTipoCategoria.id && categoria.idArea === selectedArea.id
          );
          setCategorias(validCategorias);
        })
        .catch(error => console.error('Error fetching descripciones:', error));
    }
  }, [selectedTipoCategoria, selectedArea]);

  const handleTipoCategoriaChange = (e) => {
    const tipoSeleccionado = e.value;
    setSelectedTipoCategoria(tipoSeleccionado);
    setSelectedArea(null);
    setSelectedDescripcion('');
    setPuntos('');
    setSelectedCategoriaId(null);
    setCategorias([]);
  };

  const handleAreaChange = (e) => {
    const areaSeleccionada = e.value;
    setSelectedArea(areaSeleccionada);
    setSelectedDescripcion('');
    setPuntos('');
    setSelectedCategoriaId(null);

    if (selectedTipoCategoria && areaSeleccionada) {
      fetch(`/api/categoria/findbydescripcionesporAreaporTipo/${areaSeleccionada.id}/${selectedTipoCategoria.id}`)
        .then(response => response.json())
        .then(data => {
          const validCategorias = data.filter(categoria =>
            categoria.idTipoCategoria === selectedTipoCategoria.id && categoria.idArea === areaSeleccionada.id
          );
          setCategorias(validCategorias);
        })
        .catch(error => console.error('Error fetching descripciones:', error));
    }
  };

  const handleDescripcionChange = (e) => {
    const descripcionSeleccionada = e.value;
    setSelectedDescripcion(descripcionSeleccionada);

    const tipoSeleccionado = selectedTipoCategoria;
    const areaSeleccionada = selectedArea;

    // Verifica que ambos, tipo y área, estén seleccionados
    if (!tipoSeleccionado || !areaSeleccionada) {
      console.error('Tipo de categoría o área no seleccionados');
      return;
    }

    // Realiza la llamada a la API para obtener las categorías por área y tipo
    fetch(`/api/categoria/findbydescripcionesporAreaporTipo/${areaSeleccionada.id}/${tipoSeleccionado.id}`)
      .then(response => response.json())
      .then(data => {
        // Filtra las categorías para encontrar la categoría con la descripción seleccionada
        const categoriaSeleccionada = data.find(categoria =>
          categoria.descripcion === descripcionSeleccionada
        );

        if (categoriaSeleccionada) {
          setSelectedCategoriaId(categoriaSeleccionada.idCategoria); // Asigna el idCategoria seleccionado
          setPuntos(categoriaSeleccionada.puntos); // Actualiza los puntos
          setSelectedTipoCategoriaId(categoriaSeleccionada.idTipoCategoria); // Actualiza el idTipoCategoria
          setSelectedAreaId(categoriaSeleccionada.idArea); // Actualiza el idArea
        } else {
          console.error('No se encontró la categoría seleccionada');
          setPuntos('');
          setSelectedCategoriaId(null); // Resetea el idCategoria si no se encuentra la categoría
          setSelectedTipoCategoriaId(null);
          setSelectedAreaId(null);
        }
      })
      .catch(error => console.error('Error al obtener la categoría:', error));
  };

  const handleEnviarPuntuacion = () => {
    // Verificación de campos requeridos
    if (!selectedEmpleado || !selectedCiudad || !selectedTienda || !selectedTipoCategoria || !selectedArea || !selectedDescripcion || !puntos || !comentario) {
      console.error('Por favor complete todos los campos requeridos.');
      mostrarToast('error', 'Por favor complete todos los campos requeridos.');
      return;
    }

    // Obtener el id de usuario del localStorage
    const idUsuario = localStorage.getItem('username');

    // Verificar que idUsuario tenga un valor válido
    if (!idUsuario) {
      console.error('No se encontró el id de usuario en el localStorage.');
      mostrarToast('error', 'No se encontró el id de usuario en el localStorage.');
      return;
    }

    // Construir el objeto de puntuación a enviar
    const puntuacion = {
      descripcion: comentario,
      fecha: fechaHoraActual,
      categoria: {
        id: selectedCategoriaId, // ID de la categoría seleccionada
        tipoCategoria: {
          id: selectedTipoCategoria.id,
          nombre: selectedTipoCategoria.nombre
        },
        area: {
          id: selectedArea.id,
          nombre: selectedArea.nombre
        },
        puntos: puntos,
        descripcion: selectedDescripcion,
        id_usuario: idUsuario // Asignar el id de usuario obtenido del localStorage
      },
      empleado: {
        cedula: selectedEmpleado.cedula,
        nombre: selectedEmpleado.nombre,
        codigo_almacen: selectedEmpleado.codigo_almacen,
        almacen: selectedEmpleado.almacen,
        cargo: selectedEmpleado.cargo,
        ciudad: selectedEmpleado.ciudad,
        email: selectedEmpleado.correo
      },
      id_usuario: idUsuario
    };

    // Enviar la puntuación al backend
    fetch('/api/puntuacion/save', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(puntuacion)
    })
      .then(response => {
        if (response.ok) {
          console.log('Puntuación guardada exitosamente.');
          mostrarToast('success', 'Se ha enviado la puntuación correctamente.');
          limpiarFormulario();
          handleEnviarCorreo(
            selectedEmpleado,
            puntos,
            fechaHoraActual,
            loggedUserEmail,
            selectedDescripcion,
            selectedArea
          );
        } else {
          console.error('Error al guardar la puntuación.');
          mostrarToast('error', 'Error al guardar la puntuación.');
        }
      })
      .catch(error => {
        console.error('Error al enviar la puntuación:', error);
        mostrarToast('error', 'Error al enviar la puntuación.');
      });
  };

  const handleEnviarCorreo = (
    selectedEmpleado,
    puntos,
    fecha,
    userEmail,
    selectedDescripcion,
    selectedArea
  ) => {
    const enviarCorreoEmpleado = (empleado, puntos, fecha, descripcion, area) => {
      fetch('email/enviar-correo', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          destinatarios: [empleado.correo],
          asunto: 'Notificación: Evaluación de Desempeño',
          cuerpo: `Estimado(a) ${empleado.nombre},

Te informamos que has recibido una evaluación de desempeño en nuestro sistema.

Puntos obtenidos: ${puntos}
Motivo de la evaluación: ${descripcion} - ${area.nombre}\n
Fecha de evaluación: ${fecha}

Tu desempeño es fundamental para nuestro éxito.

Atentamente,
El Equipo de Manamer`
        })
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Error al enviar el correo al empleado');
          }
          return response.json();
        })
        .then(data => {
          console.log('Correo enviado al empleado:', data);
        })
        .catch(error => {
          console.error('Error al enviar el correo al empleado:', error);
        });
    };

    const enviarCorreoEvaluador = (empleado, puntos, fecha) => {
      const userEmail = localStorage.getItem('userEmail');

      if (!userEmail) {
        console.error('No se proporcionó un destinatario válido para el correo.');
        return;
      }

      fetch('/email/enviar-correo', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          destinatarios: [userEmail],
          asunto: 'Sistema de Calificación: Nueva puntuación recibida',
          cuerpo: `Estimado/a,

Nos complace informarle que el día de hoy, ${fecha}, se ha llevado a cabo la evaluación correspondiente al desempeño del vendedor ${empleado.nombre}, otorgándole una nueva puntuación de ${puntos} puntos en nuestro Sistema de Calificación.

Agradecemos su continua participación y confianza en nuestros servicios.

¡Gracias por ser parte de Manamer!

Atentamente,
El Equipo de Manamer`
        })
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Error al enviar el correo al evaluador');
          }
          return response.json();
        })
        .then(data => {
          console.log('Correo enviado al evaluador:', data);
        })
        .catch(error => {
          console.error('Error al enviar el correo al evaluador:', error);
        });
    };

    enviarCorreoEmpleado(selectedEmpleado, puntos, fecha, selectedDescripcion, selectedArea);
    enviarCorreoEvaluador(selectedEmpleado, puntos, fecha);
  };

  const limpiarFormulario = () => {
    setSelectedEmpleado(null);
    setSelectedCiudad(null);
    setSelectedTienda(null);
    setSelectedTipoCategoria(null);
    setSelectedArea(null);
    setSelectedDescripcion('');
    setSelectedCategoriaId(null);
    setSelectedTipoCategoriaId(null);
    setSelectedAreaId(null);
    setPuntos('');
    setComentario('');
    setShowSuccessMessage(false);
  };

  const mostrarToast = (severity, message) => {
    setToastSeverity(severity);
    setToastMessage(message);
    toast.current.show({ severity: severity, summary: severity === 'success' ? 'Éxito' : 'Error', detail: message, life: 3000 });
  };

  return (
    <div className="container">
      <Toast ref={toast} position="center" />
      <div className="card-puntos">
        <div className="card-body">
          <div className="p-fluid">
            <div className="p-field">
              <label htmlFor="fechaHora">Fecha</label>
              <InputText
                id="fechaHora"
                type="text"
                value={fechaHoraActual}
                readOnly
                className="form-control"
              />
            </div>
            <div className="p-field">
              <label htmlFor="ciudad">Ciudad</label>
              <Dropdown
                id="ciudad"
                value={selectedCiudad}
                options={ciudades.map(ciudad => ({ label: ciudad, value: ciudad }))}
                onChange={(e) => setSelectedCiudad(e.value)}
                placeholder="Seleccione una ciudad"
                className="form-control" />
            </div>
            <div className="p-field">
              <label htmlFor="tienda">Tienda</label>
              <Dropdown
                id="tienda"
                value={selectedTienda}
                options={tiendas.map(tienda => ({ label: tienda, value: tienda }))}
                onChange={(e) => setSelectedTienda(e.value)}
                placeholder="Seleccione una tienda"
                disabled={!selectedCiudad}
                className="form-control"
              />
            </div>
            <div className="p-field">
              <label htmlFor="empleado">Empleado</label>
              <Dropdown
                id="empleado"
                value={selectedEmpleado}
                options={empleados.map(empleado => ({ label: empleado.nombre, value: empleado }))}
                onChange={(e) => setSelectedEmpleado(e.value)}
                placeholder="Seleccione un empleado"
                disabled={!selectedTienda}
                className="form-control"
              />
            </div>
            <div className="p-field p-grid">
              <label htmlFor="tipoCategoria" className="p-col-12 p-md-2">Tipo de Categoría</label>
              <Dropdown
                id="tipoCategoria"
                value={selectedTipoCategoria}
                options={tiposCategoria}
                onChange={handleTipoCategoriaChange}
                optionLabel="nombre"
                placeholder="Seleccionar tipo de categoría"
                className="dropdown"
              />
            </div>
            <div className="p-field p-grid">
              <label htmlFor="area" className="p-col-12 p-md-2">Área</label>
              <Dropdown
                id="area"
                value={selectedArea}
                options={areas}
                onChange={handleAreaChange}
                optionLabel="nombre"
                placeholder="Seleccionar área"
                disabled={!selectedTipoCategoria}
                className="dropdown"
              />
            </div>
            <div className="p-field p-grid">
              <label htmlFor="descripcion" className="p-col-12 p-md-2">Descripción</label>
              <Dropdown
                id="descripcion"
                value={selectedDescripcion}
                options={categorias.map(categoria => ({ label: categoria.descripcion, value: categoria.descripcion }))}
                onChange={handleDescripcionChange}
                placeholder="Seleccionar descripción"
                disabled={!selectedArea}
                className="dropdown"
              />
            </div>
            <div className="p-field p-grid">
              <label htmlFor="puntos" className="p-col-12 p-md-2">Puntos</label>
              <InputText
                id="puntos"
                value={puntos}
                onChange={(e) => setPuntos(e.target.value)}
                disabled={true}
                placeholder="Puntos"
                className="inputtext"
              />
            </div>
            <div className="p-field">
              <label htmlFor="comentario">Comentario</label>
              <InputText
                id="comentario"
                type="text"
                value={comentario}
                onChange={(e) => setComentario(e.target.value)}
                placeholder="Ingrese un comentario"
                disabled={!selectedDescripcion && !loading}
                className="form-control"
                maxLength={100}
              />
            </div>
            <div className="p-field">
              <Button
                label={loading ? "Enviando..." : "Enviar Puntuación"}
                onClick={handleEnviarPuntuacion}
                disabled={loading}
                className="btn btn-primary"
              />
            </div>
          </div>
          {showSuccessMessage && (
            <div className="alert alert-success" role="alert">
              ¡Puntuación enviada con éxito!
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
